// extracted by mini-css-extract-plugin
module.exports = {"container":"Static_container__F3tH0","mainTabs":"Static_mainTabs__D1rxK","counter":"Static_counter__ekkUV"};